import React from 'react';

const ClientLogos = () => {
  const clients = [
    { 
      name: 'Tarek Kabrit', 
      position: 'Co-founder & CEO', 
      company: 'Transportation Company',
      industry: 'Transportation',
      testimonial: 'The AI copilot has been a quiet helper that reduced back and forth communication, provided faster quotes, and gave us a steady increase in conversions.'
    },
    { 
      name: 'Sarah Johnson', 
      position: 'CTO', 
      company: 'Healthcare Startup',
      industry: 'Healthcare',
      testimonial: 'Vallen AI delivered our patient transport automation system in just 3 weeks. The results exceeded our expectations.'
    },
    { 
      name: 'Michael Chen', 
      position: 'Product Manager', 
      company: 'Tech Company',
      industry: 'Technology',
      testimonial: 'Their AI solutions helped us achieve 95% detection accuracy and significantly improved our operational efficiency.'
    },
    { 
      name: 'Emily Rodriguez', 
      position: 'Founder', 
      company: 'E-commerce Platform',
      industry: 'E-commerce',
      testimonial: 'The recommendation engine they built increased our conversion rates by 25% and customer satisfaction by 40%.'
    },
    { 
      name: 'David Kim', 
      position: 'VP of Engineering', 
      company: 'Financial Services',
      industry: 'Finance',
      testimonial: 'Their fraud detection system reduced false positives by 60% while maintaining 99.9% accuracy.'
    },
    { 
      name: 'Lisa Thompson', 
      position: 'Head of Product', 
      company: 'SaaS Platform',
      industry: 'Software',
      testimonial: 'The AI integration was seamless and the team was incredibly professional. We saw immediate ROI.'
    }
  ];

  return (
    <section className="client-logos-section py-5" style={{
      background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 80%, rgba(14, 165, 233, 0.02) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(30, 64, 175, 0.01) 0%, transparent 50%)
        `,
        zIndex: 1
      }}></div>

      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <h2 style={{
              fontSize: 'clamp(1.8rem, 3vw, 2.5rem)',
              fontWeight: '700',
              color: '#1e293b',
              marginBottom: '1rem',
              lineHeight: '1.2'
            }}>
              Trusted by Industry{' '}
              <span style={{
                background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>Leaders</span>
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#64748b',
              lineHeight: '1.6',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Real testimonials from executives and decision-makers who have experienced our AI solutions
            </p>
          </div>
        </div>

        {/* Client Testimonials Grid */}
        <div className="row g-3 g-md-4 justify-content-center">
          {clients.map((client, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-4">
              <div style={{
                background: '#ffffff',
                border: '2px solid #94a3b8',
                borderRadius: 'clamp(16px, 3vw, 20px)',
                padding: 'clamp(1.5rem, 4vw, 2rem)',
                transition: 'all 0.3s ease',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
                position: 'relative',
                overflow: 'hidden',
                minHeight: '280px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
                e.currentTarget.style.borderColor = 'rgba(14, 165, 233, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.05)';
                e.currentTarget.style.borderColor = '#94a3b8';
              }}>
              
               {/* Testimonial */}
                <p style={{
                  fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
                  color: '#64748b',
                  lineHeight: '1.6',
                  marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
                  fontStyle: 'italic',
                  flex: 1
                }}>
                  "{client.testimonial}"
                </p>

                {/* Client Info */}
                <div style={{
                  borderTop: '1px solid #cbd5e1',
                  paddingTop: '1rem'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'clamp(0.75rem, 2vw, 1rem)'
                  }}>
                    {/* Avatar */}
                    <div style={{
                      width: 'clamp(40px, 8vw, 50px)',
                      height: 'clamp(40px, 8vw, 50px)',
                      background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                      fontWeight: '700',
                      flexShrink: 0
                    }}>
                      {client.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    
                    {/* Client Details */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <h4 style={{
                        fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                        fontWeight: '700',
                        color: '#1e293b',
                        margin: '0 0 0.25rem 0',
                        lineHeight: '1.3'
                      }}>
                        {client.name}
                      </h4>
                      <p style={{
                        fontSize: 'clamp(0.75rem, 2vw, 0.85rem)',
                        color: '#0ea5e9',
                        fontWeight: '600',
                        margin: '0 0 0.25rem 0',
                        lineHeight: '1.3'
                      }}>
                        {client.position}
                      </p>
                      <p style={{
                        fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                        color: '#64748b',
                        margin: 0,
                        lineHeight: '1.3',
                        wordBreak: 'break-word'
                      }}>
                        {client.company} • {client.industry}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Row */}
        <div className="row g-3 g-md-4 mt-5">
          <div className="col-6 col-md-3">
            <div style={{
              textAlign: 'center',
              padding: 'clamp(1rem, 3vw, 1.5rem)',
              background: 'rgba(255, 255, 255, 0.8)',
              borderRadius: 'clamp(12px, 2.5vw, 16px)',
              border: '2px solid rgba(14, 165, 233, 0.4)',
              minHeight: 'clamp(100px, 20vw, 120px)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <div style={{
                fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                fontWeight: '800',
                color: '#0ea5e9',
                marginBottom: '0.5rem',
                lineHeight: '1'
              }}>
                10+
              </div>
              <div style={{
                fontSize: 'clamp(0.75rem, 2vw, 0.9rem)',
                color: '#64748b',
                fontWeight: '600',
                lineHeight: '1.2'
              }}>
                Happy Clients
              </div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div style={{
              textAlign: 'center',
              padding: 'clamp(1rem, 3vw, 1.5rem)',
              background: 'rgba(255, 255, 255, 0.8)',
              borderRadius: 'clamp(12px, 2.5vw, 16px)',
              border: '2px solid rgba(14, 165, 233, 0.4)',
              minHeight: 'clamp(100px, 20vw, 120px)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <div style={{
                fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                fontWeight: '800',
                color: '#0ea5e9',
                marginBottom: '0.5rem',
                lineHeight: '1'
              }}>
                5+
              </div>
              <div style={{
                fontSize: 'clamp(0.75rem, 2vw, 0.9rem)',
                color: '#64748b',
                fontWeight: '600',
                lineHeight: '1.2'
              }}>
                Industries Served
              </div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div style={{
              textAlign: 'center',
              padding: 'clamp(1rem, 3vw, 1.5rem)',
              background: 'rgba(255, 255, 255, 0.8)',
              borderRadius: 'clamp(12px, 2.5vw, 16px)',
              border: '2px solid rgba(14, 165, 233, 0.4)',
              minHeight: 'clamp(100px, 20vw, 120px)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <div style={{
                fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                fontWeight: '800',
                color: '#0ea5e9',
                marginBottom: '0.5rem',
                lineHeight: '1'
              }}>
                98%
              </div>
              <div style={{
                fontSize: 'clamp(0.75rem, 2vw, 0.9rem)',
                color: '#64748b',
                fontWeight: '600',
                lineHeight: '1.2'
              }}>
                Success Rate
              </div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div style={{
              textAlign: 'center',
              padding: 'clamp(1rem, 3vw, 1.5rem)',
              background: 'rgba(255, 255, 255, 0.8)',
              borderRadius: 'clamp(12px, 2.5vw, 16px)',
              border: '2px solid rgba(14, 165, 233, 0.4)',
              minHeight: 'clamp(100px, 20vw, 120px)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <div style={{
                fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                fontWeight: '800',
                color: '#0ea5e9',
                marginBottom: '0.5rem',
                lineHeight: '1'
              }}>
                8-12
              </div>
              <div style={{
                fontSize: 'clamp(0.75rem, 2vw, 0.9rem)',
                color: '#64748b',
                fontWeight: '600',
                lineHeight: '1.2'
              }}>
                Weeks Delivery
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
